var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",attrs:{"id":`copy-form-to-clipboard-${_vm.form.id}`,"title":`Copy ${_vm.text} to clipboard`},on:{"click":function($event){$event.preventDefault();return _vm.copy.apply(null, arguments)}}},[_c('copy-icon',{attrs:{"size":"1.5x"}}),_c('span',{staticClass:"padding"},[_vm._v(" Copy link to clipboard")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }